const externalActions = {
  greynoiseIp: {
    type: "http-get",
    title: "Lookup on GreyNoise (IP)",
    fieldNames: ["source_ip", "destination_ip", "host_ip", "network_forwarded_ip"],
    options: {
      linkTemplate: "https://www.greynoise.io/viz/ip/{field_value}"
    }
  },
  virustotalIp: {
    type: "http-get",
    title: "Lookup on Virustotal (IP)",
    fieldNames: ["source_ip", "destination_ip", "host_ip", "network_forwarded_ip"],
    options: {
      linkTemplate: "https://www.virustotal.com/gui/ip-address/{field_value}/detection"
    }
  },
  virustotalHash: {
    type: "http-get",
    title: "Lookup on Virustotal (Hash)",
    fieldNames: ["hash_md5", "hash_sha1", "hash_sha256"],
    options: {
      linkTemplate: "https://www.virustotal.com/gui/file/{field_value}/detection"
    }
  },
  alienvaultHash: {
    type: "http-get",
    title: "Lookup on Alienvault OTX (Hash)",
    fieldNames: ["hash_md5", "hash_sha1", "hash_sha256", "hash_imphash"],
    options: {
      linkTemplate: "https://otx.alienvault.com/indicator/file/{field_value}/"
    }
  },
  hybridanalysisImpHash: {
    type: "http-get",
    title: "Lookup on Hybrid Analysis (Imphash)",
    fieldNames: ["hash_imphash"],
    options: {
      linkTemplate: "https://www.hybrid-analysis.com/search?query=imphash%3A%22{field_value}%22"
    }
  },
  malshare: {
    type: "http-get",
    title: "Lookup on Malshare (Hash)",
    fieldNames: ["hash_md5", "hash_sha1", "hash_sha256", "hash_imphash"],
    options: {
      linkTemplate: "https://malshare.com/search.php?query={field_value}"
    }
  },
  robtexIp: {
    type: "http-get",
    title: "Lookup on Robtex",
    fieldNames: ["source_ip", "destination_ip", "host_ip", "network_forwarded_ip"],
    options: {
      linkTemplate: "https://www.robtex.com/ip-lookup/{field_value}"
    }
  },
  ipWatchlist: {
    type: "lookup-table",
    options: {
      fieldType: "ip"
    }
  },
  userWatchlist: {
    type: "lookup-table",
    options: {
      fieldType: "user"
    }
  },
  hashWatchlist: {
    type: "lookup-table",
    options: {
      fieldType: "hash"
    }
  },
  portWatchlist: {
    type: "lookup-table",
    options: {
      fieldType: "port"
    }
  },
  domainWatchlist: {
    type: "lookup-table",
    options: {
      fieldType: "domain"
    }
  },
  geolocationWatchlist: {
    type: "lookup-table",
    options: {
      fieldType: "geolocation"
    }
  },
  fileWatchlist: {
    type: "lookup-table",
    options: {
      fieldType: "file"
    }
  }
};
export default externalActions;
